import { Tooltip } from "react-tooltip";
import useLanguage from "@axvdex/hooks/useLanguage";
import { SaleStatus } from "@axvdex/types/solana/outbid";

type TimeLeftTooltipProps = {
  status: SaleStatus;
  startTimestamp: number;
  whitelistDuration: number;
  bonusDuration: number;
  endTimestamp: number;
};

export function TimeLeftTooltip({
  status,
  startTimestamp,
  whitelistDuration,
  bonusDuration,
  endTimestamp,
}: TimeLeftTooltipProps) {
  const { i18 } = useLanguage();
  return (
    <Tooltip
      id="tooltip_timeInfo"
      place="bottom"
      style={{ backgroundColor: "var(--dark)", color: "white", zIndex: 3 }}
      render={() => (
        <div style={{ textAlign: "right" }}>
          <h3 style={{ marginBottom: ".5em" }}>Sale times</h3>
          <small>
            {i18("Start", "sales.start")}: {new Date(startTimestamp * 1000).toLocaleString()}
          </small>
          <br />
          <small>
            {i18("VIP end", "sales.vipEnd")}: {new Date((startTimestamp + whitelistDuration) * 1000).toLocaleString()}
          </small>{" "}
          <br />
          <small>
            {i18("Bidding end", "sales.biddingEnd")}: {new Date((endTimestamp - bonusDuration) * 1000).toLocaleString()}
          </small>
          {["BonusBidding", "EndedNotSoldOut", "EndedBonusTimeSoldOut"].includes(status) && (
            <>
              <br />
              <small>
                {i18("Bonus end", "sales.bonusEnd")}: {new Date(endTimestamp * 1000).toLocaleString()}
              </small>
            </>
          )}
        </div>
      )}
    />
  );
}
